import React, { useState } from "react";
import { Box, Container, Typography, Grid, Paper } from "@mui/material";
import { FaShieldAlt, FaLeaf, FaTruck, FaCheckCircle } from "react-icons/fa";

import podSobre from "../assets/podsobre.png";

const SobreHome = () => {
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

    const handleMouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setMousePos({
            x: (e.clientX - rect.left) / rect.width - 0.5,
            y: (e.clientY - rect.top) / rect.height - 0.5,
        });
    };

    return (
        <Box
            onMouseMove={handleMouseMove}
            sx={{
                marginTop: -20,
                mb: -10,
                width: "100%",
                py: { xs: 8, md: 30 },
                background: "linear-gradient(180deg, var(--backgroundPage), #d8dde6)",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* BACKGROUND DINÂMICO */}
            <Box
                sx={{
                    position: "absolute",
                    top: `calc(50% + ${mousePos.y * 50}px)`,
                    left: `calc(50% + ${mousePos.x * 50}px)`,
                    width: 800,
                    height: 800,
                    background:
                        "radial-gradient(circle, rgba(30,43,78,0.28), rgba(30,43,78,0))",
                    filter: "blur(120px)",
                    transform: "translate(-50%, -50%)",
                    transition: "transform 0.12s linear",
                }}
            />

            <Container maxWidth="xl" sx={{ position: "relative", zIndex: 10 }}>
                <Grid
                    container
                    spacing={6}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    {/* TEXTO ESQUERDA */}
                    <Grid item xs={12} md={6}>
                        <Typography
                            sx={{
                                fontSize: { xs: 32, md: 42 },
                                fontWeight: 800,
                                color: "var(--cinza)",
                                lineHeight: 1.2,
                                width: { xs: "100%", md: "80%" },
                            }}
                        >
                            Descubra uma nova experiência com a EMMA
                        </Typography>

                        <Typography
                            sx={{
                                mt: 3,
                                fontSize: 18,
                                color: "#444",
                                lineHeight: 1.7,
                                maxWidth: 520,
                            }}
                        >
                            Priorizamos sempre trazer as novidades e inovações do mercado, seja marca, produtos ou sabores. Na EMMA, a qualidade dos produtos, originalidade e confiança se unem para você se tornar parte da Família!
                        </Typography>

                        <Typography
                            sx={{
                                mt: 2,
                                fontSize: 16,
                                color: "#555",
                                maxWidth: 520,
                            }}
                        >
                            Nosso compromisso é elevar o padrão e a acessibilidade dos Pods no Brasil com transparência e segurança.
                        </Typography>
                    </Grid>

                    {/* IMAGEM DIREITA */}
                    <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{ display: "flex", justifyContent: "center", position: "relative" }}
                    >
                        {/* Glow Animado */}
                        <Box
                            sx={{
                                position: "absolute",
                                width: 380,
                                height: 380,
                                background: "rgba(30,43,78,0.35)",
                                borderRadius: "50%",
                                filter: "blur(90px)",
                                zIndex: 1,
                                transform: `translate(${mousePos.x * 25}px, ${mousePos.y * 25}px)`,
                                transition: "0.15s linear",
                            }}
                        />

                        <Box
                            component="img"
                            src={podSobre}
                            alt="Pod Premium"
                            sx={{
                                width: { xs: "100%", sm: 280, md: 380 },
                                maxWidth: "100%",
                                position: "relative",
                                zIndex: 2,
                                filter: "drop-shadow(0px 18px 35px rgba(0,0,0,0.25))",
                                transform: `translate(${mousePos.x * 15}px, ${mousePos.y * 15}px)`,
                                transition: "transform 0.15s linear",
                                objectFit: "contain",
                            }}
                        />
                    </Grid>
                </Grid>

                {/* BENEFÍCIOS */}
                <Grid
                    container
                    spacing={{ xs: 2, md: 4 }}
                    justifyContent="center"
                    sx={{ mt: { xs: 6, md: 10 } }}
                >
                    {[
                        { icon: <FaCheckCircle size={22} />, title: "Qualidade" },
                        { icon: <FaShieldAlt size={22} />, title: "Segurança" },
                        { icon: <FaLeaf size={22} />, title: "Sabores e fragrâncias únicas" },
                        { icon: <FaTruck size={22} />, title: "Vários métodos de envio" },
                    ].map((item, i) => (
                        <Grid key={i} item xs={12} sm={6} md={3}>
                            <Paper
                                sx={{
                                    p: { xs: 2, md: 3 },
                                    height: { xs: "auto", md: 140 },
                                    width: { xs: 320, md: 280 },
                                    borderRadius: "18px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: { xs: 2, md: 0 },
                                    flexDirection: { xs: "row", md: "column" },
                                    textAlign: { xs: "left", md: "center" },
                                    boxShadow: {
                                        xs: "0 2px 8px rgba(0,0,0,0.08)",
                                        md: "0 5px 20px rgba(0,0,0,0.1)",
                                    },
                                    transition: "0.3s",
                                    "&:hover": {
                                        md: {
                                            transform: "translateY(-6px)",
                                            boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
                                        },
                                    },
                                }}
                            >
                                {/* ICON */}
                                <Box
                                    sx={{
                                        minWidth: 42,
                                        minHeight: 42,
                                        borderRadius: "12px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "var(--azul)",
                                        background: "rgba(30,43,78,0.06)",
                                    }}
                                >
                                    {item.icon}
                                </Box>

                                {/* TEXT */}
                                <Typography
                                    sx={{
                                        fontWeight: 800,
                                        fontSize: 15,
                                        color: "var(--cinza)",
                                    }}
                                >
                                    {item.title}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default SobreHome;
